export default [
  {
    path: '/reports/ticket',
    name: 'Report_Tickets',
    component: () => import('@/views/report/ticket/index.vue'),
    meta: {
      pageTitle: 'گزارشات نامه ها',
      authRequired: true,
      permission: 'reports.tickets',
    },
  },
  {
    path: '/reports/task',
    name: 'Report_Tasks',
    component: () => import('@/views/report/task/index.vue'),
    meta: {
      pageTitle: 'گزارشات وظایف',
      authRequired: true,
      permission: 'reports.tasks',
    },
  },
  {
    path: '/reports/agendas',
    name: 'Report_Agendas',
    component: () => import('@/views/report/agenda/index.vue'),
    meta: {
      pageTitle: 'گزارشات صورتجلسات',
      authRequired: true,
      permission: 'reports.agendas',
    },
  },
  {
    path: '/reports/requests',
    name: 'Report_Requests',
    component: () => import('@/views/report/request/index.vue'),
    meta: {
      pageTitle: 'گزارشات درخواست ها',
      authRequired: true,
      permission: 'reports.requests',
    },
  },
]
